// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:53:35

export default {
  "id": "twisted-rope",
  "slug": "twisted-rope",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d006eab47d334b61bbc1cf621691e473-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d006eab47d334b61bbc1cf621691e473/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Twisted Rope",
      "description": "Get ready for a mind-bending challenge! ? Twisted Rope Puzzle 3D is a captivating game that will put your problem-solving skills to the test. Dive into a colorful world of tangled ropes and work your way through increasingly complex puzzles.",
      "instructions": "Carefully examine the tangled mess. ?\nTap and drag the ropes to untangle them. ?",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "rope"
      ]
    },
    "zh-CN": {
      "title": "扭曲的绳索",
      "description": "准备好迎接一场脑力挑战！？扭曲绳索谜题3D是一款引人入胜的游戏，将考验你的解决问题的能力。沉浸在一个五彩斑斓的错综复杂绳索的世界中，逐步解决越来越复杂的谜题。",
      "instructions": "仔细检查这团乱麻。\n轻触并拖动绳索以解开它们。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "绳索"
      ]
    },
    "zh-TW": {
      "title": "扭曲繩索",
      "description": "準備迎接一個讓你腦筋打結的挑戰！？彎曲繩索拼圖3D是一款迷人的遊戲，將對你的問題解決能力提出挑戰。沉浸在一個五彩繽紛的纏結繩索世界，並逐步解開越來越複雜的謎題。",
      "instructions": "仔細檢查這個亂糟糟的紛亂。?\n點擊並拖動繩索來解開它們。?",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "繩子"
      ]
    },
    "zh-HK": {
      "title": "扭曲繩索",
      "description": "準備迎接一場驚艷的挑戰！？扭曲繩索迷宮3D是一款吸引人的遊戲，將考驗你的解題技巧。墮入一個五彩繽紛的繩索糾結世界，並逐步解開越來越複雜的謎題。",
      "instructions": "仔細檢查這個雜亂的綜紛。？\n點擊並拖動繩子來解開它們。？",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "繩子"
      ]
    },
    "ja": {
      "title": "歪んだロープ",
      "description": "心を躍らせる挑戦に備えてください！？Twisted Rope Puzzle 3Dは、あなたの問題解決スキルを試す魅力的なゲームです。混乱した紐の色鮮やかな世界に飛び込み、次第に複雑なパズルを解き明かしていきましょう。",
      "instructions": "複雑なごちゃごちゃを慎重に調べる。？\nロープをタップして引っ張りながら解結する。？",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "ロープ"
      ]
    },
    "ko": {
      "title": "곡사로프",
      "description": "대脑을 젤리하는 도전을 준비하세요! Twisted Rope Puzzle 3D는 문제 해결 능력을 테스트하는 매혹적인 게임입니다. 엉망이 돼버린 나줄로 꽂힌 colorful world에 잠기고, 점점 더 복잡해지는 패uzzle를 통해 나아가세요.",
      "instructions": "혼란스러운 혼자를 주의 깊게 확인하세요. ?\nropes를 탭하고 드래그하여 풀어주세요. ?",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "1명의 플레이어",
        "나무줄"
      ]
    },
    "fr": {
      "title": "Nœud Tordu",
      "description": "Préparez-vous à un défi cérébral éblouissant ! ? Twisted Rope Puzzle 3D est un jeu captivant qui mettra vos compétences de résolution de problèmes à l'épreuve. Plongez dans un monde coloré de cordes enchevêtrées et travaillez votre way à travers des puzzles de plus en plus complexes.",
      "instructions": "Examinez attentivement le désordre enchevêtré.\nTouchez et faites glisser les cordes pour les dénuder.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "corde"
      ]
    }
  }
};
